/**
 * Options for how the patient is displayed in Sammelrechnungen
 */
export enum PatientNameFormat {
	LAST_NAME_COMMA_FIRST_NAME = 1, // Nachname, Vorname
	LAST_NAME_COMMA_FIRST_NAME_COMMA_TITLE = 2, // Nachname, Vorname, Titel
	CODE_TITLE_LAST_NAME_FIRST_NAME_BIRTHDATE = 3, // Code: Titel Nachname Vorname (Geburtsdatum)
}

export const patientNameFormatOptions = [
	{
		value: PatientNameFormat.LAST_NAME_COMMA_FIRST_NAME,
		label: "Nachname, Vorname",
	},
	{
		value: PatientNameFormat.LAST_NAME_COMMA_FIRST_NAME_COMMA_TITLE,
		label: "Nachname, Vorname, Titel",
	},
	{
		value: PatientNameFormat.CODE_TITLE_LAST_NAME_FIRST_NAME_BIRTHDATE,
		label: "Code: Titel Nachname Vorname (Geburtsdatum)",
	},
];

/**
 * Options for how the Sammelrechnungen are sorted
 * On the DB the default value is 3 (old standard behavior was to sort by patient last name)
 */
export enum SammelrechnungenSortingOptions {
	JOB_CODE = 1,
	JOB_TITLE = 2,
	PATIENT_LAST_NAME = 3,
	PATIENT_CODE = 4,
}

interface SortingOptionDisabledProps {
	is_inv_w_pat_data: boolean;
	is_inv_w_job_title: boolean;
	patient_name_format: PatientNameFormat;
}

export const srgSortingOptions = [
	{
		value: SammelrechnungenSortingOptions.JOB_CODE,
		label: "Auftragscode",
		disabled: () => false,
	},
	{
		value: SammelrechnungenSortingOptions.JOB_TITLE,
		label: "Auftragstitel",
		disabled: (props: SortingOptionDisabledProps) =>
			!props.is_inv_w_job_title,
	},
	{
		value: SammelrechnungenSortingOptions.PATIENT_LAST_NAME,
		label: "Nachname des Patienten",
		disabled: (props: SortingOptionDisabledProps) =>
			!props.is_inv_w_pat_data,
	},
	{
		value: SammelrechnungenSortingOptions.PATIENT_CODE,
		label: "Code des Patienten",
		disabled: (props: SortingOptionDisabledProps) =>
			!props.is_inv_w_pat_data ||
			props.patient_name_format !==
				PatientNameFormat.CODE_TITLE_LAST_NAME_FIRST_NAME_BIRTHDATE,
	},
];

export enum TpTier {
	SV = 0,
	PP1 = 1,
	PP2 = 2,
	PP3 = 3,
}

export enum TpValue {
	OLD = 5.55,
	NEW = 1.0,
}

export enum ConfigurationColumns {
	DOCUMENTS = "documents_config",
}

/**
 * V1 main bucket, guarded via RLS on public.files (if you have access to the entry in public.files, you have access to the path specified in the path_name column)
 * - read is guarded by RLS on public.files
 * - anyone can upload if authenticated
 *
 * In ORG_V1 every organization has its own folder by org_id and can only access the folder of their organization (via org_id in app_metadata). The paths inside that folder don't matter.
 * - all operations are allowed in one's own folder
 *
 * PUBLIC_IMAGES is for profile pictures and logos
 * - make sure to only upload to folders secured with a uuid
 * - only image uploads are allowed (image/*)
 * - use the public bucket for profile pictures and logos
 */
export enum StorageBucketsEnum {
	V1 = "v1",
	ORG_V1 = "org_v1",
	PUBLIC_IMAGES = "pub_img",
}

export enum Currency {
	CHF = "CHF",
	EUR = "EUR",
}

export enum RolesEnum {
	OWNER = 0,
	ADMIN = 1,
	MEMBER = 2,
}

export enum DefaultValues {
	TP_VALUE = TpValue.NEW,
	TP_TIER = TpTier.PP2,
	TP_VARIATION = 0,
	TAX_RATE = 8.1,
}
